import { useToken } from "@/global_state";
import { useEffect } from "react";

export default function Logout() {
  const [authToken, setAuthToken] = useToken();

  const logout = () => {
    localStorage.clear();
    setAuthToken(null);
  };

  useEffect(() => {
    logout();
    document.location.href = "/";
  }, []);

  return <></>;
}
